import { useRef } from 'react';

export const useModalHandler = () => {
	const ref = useRef({ show: () => {}, hide: () => {} });

	const showModal = () => ref.current.show();

	return { ref, showModal };
};
